import { getTimestamp } from '@src/main/shared/utils/dateUtils';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const exportToPdf = <T extends Record<string, unknown>>(
  data: T[],
  fileName: string = 'data.pdf',
) => {
  // eslint-disable-next-line new-cap
  const doc = new jsPDF({
    orientation: 'landscape',
  });

  if (data.length === 0) {
    return;
  }

  const columns = Object.keys(data[0]).map((key) => ({ header: key, dataKey: key }));
  const rows = data.map((item) =>
    Object.keys(item).reduce(
      (acc, key) => {
        const val = item[key];
        acc[key] = val !== undefined && val !== null ? String(val) : '';
        return acc;
      },
      {} as Record<string, string>,
    ),
  );

  autoTable(doc, {
    columns,
    body: rows,
    styles: { fontSize: 8 },
    headStyles: {
      fillColor: [215, 25, 45],
      textColor: [255, 255, 255],
      fontStyle: 'bold',
    },
    margin: { top: 20 },
  });

  const timestamp = getTimestamp();
  doc.save(`${fileName}_${timestamp}.pdf`);
};
